import { Component, Input, OnInit } from '@angular/core';
import { environment } from '@base/environments/environment';
import { Constants } from 'src/app/models/constants';
import { QRButton } from 'src/app/models/qr-button.model';
import { QRDialog } from 'src/app/models/qr-dialog.model';
import { GetJupiterService } from 'src/app/services/get-jupiter.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { SwiperOptions } from 'swiper';
import { UserSessionService } from '../../services/user-session.service';
import { LogedUser } from '../../core/models/logged-user.model';

@Component({
  selector: 'app-jupiter-block',
  templateUrl: './jupiter-block.component.html',
  styleUrls: ['./jupiter-block.component.scss'],
})
export class JupiterBlockComponent implements OnInit {
  @Input() data?: {
    agencyId: number | string;
    agencyName: string;
    userId: string;
    module: string;
  };
  readonly NODE_ENV = environment.node;
  readonly NODE_AR = Constants.TENANT_ID_AR;
  readonly NODE_UY = Constants.TENANT_ID_UY;
  readonly NODE_EC = Constants.TENANT_ID_EC;
  readonly NODE_PY = Constants.TENANT_ID_PY;

  buttonWithIcon40pxHierarchy1: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Comenzar',
    icon: Constants.ICONS.ARROW_RIGHT_FULL,
  };

  swiperConfig: SwiperOptions = {
    navigation: {
      nextEl: '.button-next',
      prevEl: '.button-prev',
    },
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    slidesPerView: 2.65,
    speed: 800,
    grabCursor: true,
  };

  dialogSuccess: QRDialog = {
    isVisible: false,
    width: '744px',
    height:'472px',
    title: 'QR Júpiter',
    textButtonAction: 'Ir a la página principal',
    textButtonCancel: '',
    componentToLoad: QRDialog.DIALOG_JUPITER_BLOCK,
    value: '',
  };

  cardsArray: any[] = [
    {
      icon: Constants.ICONS.APPLICATION_IMPORT,
      title: 'Importador de captaciones',
      sub: 'Automatización de la carga manual de Captaciones.',
    },
    {
      icon: Constants.ICONS.BAR_CHART,
      title: 'Reservómetro histórico',
      sub: 'Gráfico con la evolución de tus reservas a cobrar.',
    },
    {
      icon: Constants.ICONS.TABLE_CHART,
      title: 'Dashboard RR.HH',
      sub: 'Una pantalla completa con datos estadísticos de tus Agentes y promedios de la oficina.',
    },
    {
      icon: Constants.ICONS.TROPHY,
      title: 'Premios regionales',
      sub: 'Resumen de premios interanuales de tus Agentes.',
    },
    {
      icon: Constants.ICONS.SUMMARIZE,
      title: 'Reporte de compartidas',
      sub: 'Reporte de operaciones compartidas con otras oficinas y también dentro de tu oficina.',
    },
    {
      icon: Constants.ICONS.OUTGOING_EMAIL,
      title: 'Solicitud de update de reservas',
      sub: 'Envía mails a los Agentes que tengan reservas en negociación y conformado, solicitando un update directamente desde el Reservómetro.',
    },
  ];

  constructor(
    private readonly getJupiterService: GetJupiterService,
    private readonly snackbarService: SnackbarService
  ) {}

  ngOnInit(): void {
    if (this.NODE_ENV != this.NODE_AR) {
      //UY, EC y PY le borra las primeras dos cards
      this.cardsArray.splice(0, 2);
    }
  }

  //Funcion deprecada momentaneamente, enviaba data a un servicio de mails
  onStart() {
    if (this.data) {
      this.getJupiterService.post(this.data, '').then((response: any) => {
        if (response?.body?.success) {
          this.dialogSuccess = { ...this.dialogSuccess, isVisible: true };
        } else {
          this.snackbarService.openSnackBar('Se ha producido un error', '');
        }
      });
    }
  }

  //Te lleva al chat de whatsapp del bot de Q&R con un mensaje dinamico
  onSendWhatsappBot() {
    const LOGGED_USER_JSON: string | null = localStorage.getItem(
      UserSessionService.LOGGED_USER
    );
    if (LOGGED_USER_JSON) {
      const LOGGED_USER: LogedUser | undefined = JSON.parse(LOGGED_USER_JSON);
      const FULL_NAME_USER = this.capitalizeWords(LOGGED_USER?.name);
      const AGENCY_NAME = LOGGED_USER?.agency_name;
      const MODULE_SUFFIX = this.data?.module
        ? ` Módulo: ${this.data.module}.`
        : '';
      const MSG: string = `Hola! Soy ${FULL_NAME_USER} de RE/MAX ${AGENCY_NAME}. Estoy interesado en conocer más sobre la versión PRO+ de QR Gestión.${MODULE_SUFFIX}`;
      const URL: string =
        'https://web.whatsapp.com/send?phone=5491127211393&text=' +
        encodeURIComponent(MSG);
      window.open(URL, '_blank');
    }
  }

  capitalizeWords(str: string | undefined): string {
    const STRING_TO_CAPITALIZE = str ?? '';
    return STRING_TO_CAPITALIZE.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  onDialogSuccess($event: any) {
    if ($event) {
      location.href = '/home';
    }
  }
}
